
import { useNavigate } from 'react-router-dom'
interface props{
  sidebarOpen:boolean,
  userAccessId:number,
}
function SideBar({sidebarOpen,userAccessId}:props) {
  const navigate =useNavigate();
  //console.log(sidebarOpen);
  return (
   
       <div
          className={`sidebar bg-white border-end shadow-sm p-3 ${
            sidebarOpen ? 'active' : ''
          }`}
        >
          <h5 className="text-primary mb-3">Navigation</h5>
          <ul className="list-unstyled">
            <li><a href="#" onClick={() => navigate("/home")} className="d-block py-2 px-2 rounded text-decoration-none text-dark sidebar-link">🏠 Home</a></li>
            {userAccessId == 1 && 
            <>
             <li><a href="#" onClick={() => navigate("/questions/list")} className="d-block py-2 px-2 rounded text-decoration-none text-dark sidebar-link">📄 List Of Questions</a></li>
            <li><a href="#" onClick={() => navigate("/questions/add")} className="d-block py-2 px-2 rounded text-decoration-none text-dark sidebar-link">📄 Add Questions</a></li>
            </>
            }
            <li><a href="#" onClick={() => navigate("/startquiz/quiz/continue")} className="d-block py-2 px-2 rounded text-decoration-none text-dark sidebar-link">📄 Continue Quiz</a></li>
  
          </ul>
        </div>
   
  )
}

export default SideBar